export default "__VITE_ASSET__BljzY5_r__"